import { render, staticRenderFns } from "./particularDetail.vue?vue&type=template&id=2c33740a&scoped=true&"
import script from "./particularDetail.vue?vue&type=script&lang=js&"
export * from "./particularDetail.vue?vue&type=script&lang=js&"
import style0 from "./particularDetail.vue?vue&type=style&index=0&id=2c33740a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c33740a",
  null
  
)

export default component.exports